import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage';

import ContactRequestsReducer from "./contactRequestsReducers";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  root: ContactRequestsReducer
});

export default persistReducer(persistConfig, rootReducer);